import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "lang-select" }
const _hoisted_2 = { class: "text-center items" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["alt", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "text-primary text-center" }, "Language", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.languages, (l, i) => {
        return (_openBlock(), _createElementBlock("a", {
          key: i,
          href: '/' + i + _ctx.$route.path,
          class: _normalizeClass({'active': $setup.config.lang.iso === i})
        }, [
          _createElementVNode("img", {
            alt: $setup.config.lang.country,
            src: $setup.flag(i),
            width: "20"
          }, null, 8, _hoisted_4),
          _createElementVNode("span", null, _toDisplayString(l), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}